const error = {
  userLimitReached: "Limite de usuários alcançado.",
};

export { error };
